import * as React from "react"
import Svg, { SvgProps, Path } from "react-native-svg"
const EditPenIcon = (props: SvgProps) => (
  <Svg
    
    width={24}
    height={24}
    fill="none"
    {...props}
  >
    <Path
      fill="#000"
      d="M6.493 17.509H7.53l7.885-7.882-1.04-1.04-7.882 7.888v1.034Zm-.923.923v-2.35L15.8 5.827c.092-.083.193-.147.305-.192a.941.941 0 0 1 .356-.067 1.03 1.03 0 0 1 .694.264l1.02 1.024a.87.87 0 0 1 .2.321 1.034 1.034 0 0 1-.005.713.856.856 0 0 1-.196.307L7.92 18.432H5.57Zm9.317-9.317-.511-.528 1.039 1.04-.528-.512ZM10 17.5h7v.95h-7v-.95Z"
    />
  </Svg>
)
export default EditPenIcon
